import { RevealSection } from "../motion/RevealSection";
import { buildWhatsAppLink } from "../../lib/whatsapp";
import { trackWhatsAppClickConversion } from "../../lib/gtag";
import { MessageCircle, MapPin } from "lucide-react";

export const Contact = ({ content }) => {
  const number = content?.whatsapp_number;
  return (
    <section id="contacto" className="relative bg-twp-charcoal py-24 md:py-36 px-6 md:px-16">
      <div className="max-w-4xl mx-auto text-center">
        <RevealSection>
          <span className="text-twp-gold text-xs uppercase tracking-[0.35em]">06 — Contacto</span>
          <h2 className="font-serif-display text-4xl md:text-6xl text-white mt-4 mb-8">
            Cuéntanos sobre tu evento
          </h2>
        </RevealSection>

        <RevealSection delay={0.1}>
          <div className="flex items-center justify-center gap-2 text-white/70 mb-3">
            <MapPin size={18} className="text-twp-gold" />
            <span data-testid="contact-city">{content?.contact_city || "Querétaro"}</span>
          </div>
          <p data-testid="contact-note" className="text-white/60 text-sm max-w-xl mx-auto mb-10">
            {content?.contact_note}
          </p>
        </RevealSection>

        <RevealSection delay={0.2}>
          {number && (
            <a
              data-testid="contact-whatsapp-button"
              href={buildWhatsAppLink(number, "Hola, quiero más información sobre sus servicios de fotografía y video.")}
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackWhatsAppClickConversion}
              className="inline-flex items-center gap-3 px-10 py-5 bg-twp-gold text-black text-xs uppercase tracking-[0.2em] font-semibold hover:bg-white transition-colors duration-300"
            >
              <MessageCircle size={18} /> Enviar WhatsApp
            </a>
          )}
        </RevealSection>
      </div>
    </section>
  );
};
